module.exports = __webpack_public_path__ + "static/media/Logo epicode.824ac06e.png";